/* eslint-disable react/style-prop-object */
import './App.css';
import './css/bootstrap.min.css'
import './css/style.css'
import './css/responsive.css'
// import './css/style_color.css';
import 'primereact/resources/themes/saga-blue/theme.css';  // choose your theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { BrowserRouter,  Route,  Routes } from 'react-router-dom';
import InitialComponent from './tracking/InitialPageComponent';
import { PrimeReactProvider } from 'primereact/api';
import FormContentComponent from './tracking/FormContentComponent';
function App() {
  return (
    <BrowserRouter>
      <PrimeReactProvider >
          <Routes>
            <Route path="/" element={<InitialComponent />} />
            <Route path="/track" element={<FormContentComponent />} />
            <Route path="/:trackingNumberFromURL" element={<FormContentComponent />} />
          </Routes>
        </PrimeReactProvider>
     </BrowserRouter>

  )
}

export default App;
